import { useEffect, useState } from "react";

import { SpeakerProps } from "./useSessions";
import { db } from "../firebase/config";
import useEvent from "./useEvent";

export interface RoomProps {
  title: string;
  src: string;
  open: boolean;
  forceOpen: boolean;
  speaker?: SpeakerProps;
}

const useRoom = (roomID?: number) => {
  const event = useEvent();
  const [room, setRoom] = useState<RoomProps | undefined>();

  useEffect(() => {
    if (roomID) {
      const getSpeaker = async (speakerID: string) => {
        const speakerRef = await db.collection("speakers").doc(speakerID).get();
        const speakerData = speakerRef.data();
        return {
          firstname: "",
          lastname: "",
          link: `/${event}/speakers/${speakerID}`,
          ...speakerData,
        };
      };

      const fetch = async () => {
        db.collection("rooms")
          .doc(roomID.toString())
          .onSnapshot(async (docRef) => {
            const roomData = docRef.data();
            const { speaker } = roomData || {};

            setRoom({
              title: roomData?.title || "",
              src: roomData?.src || "",
              open: roomData?.open,
              forceOpen: roomData?.forceOpen,
              speaker: speaker ? await getSpeaker(speaker.id) : undefined,
            });
          });
      };

      fetch();
    }
  }, [roomID, event]);

  return room;
};

export default useRoom;
